module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "powered-by-akash-white.97304638.svg";